import HomePage from './HomePage.component'

export default HomePage
